import { useContext, useMemo, Fragment } from "react";
import { MenuItem, Divider, ListSubheader } from "@mui/material";
import { ModuleContext } from "../../context/ModuleContext";
import { ManagedAccountContext } from "../../context/ManagedAccountContext";
import { useOktaAuth } from "@okta/okta-react";

import { ActivityLog } from "../../operations/ActivityLog";
import { UpdateManagedAccount } from "../../operations/managed_accounts/UpdateManagedAccount";
import { DeleteManagedAccount } from "../../operations/managed_accounts/DeleteManagedAccount";

const WSU_CRIMSON = "#A60F2D";

const pillSx = {
  backgroundColor: WSU_CRIMSON,
  color: "#ffffff",
  borderRadius: "999px",
  mx: 1,
  mb: 0.75,
  px: 2,
  py: 0.5,
  fontSize: "0.8rem",
  fontFamily: "'Montserrat', Arial, sans-serif",
  fontWeight: 500,
  minHeight: 32,
  "&:hover": {
    backgroundColor: "#8a0c25",
  },
};

const sectionSx = {
  fontFamily: "'Montserrat', Arial, sans-serif",
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: "0.07em",
  textTransform: "uppercase",
  color: "#4D4D4D",
  lineHeight: "28px",
  mt: 0.5,
};

export const ManagedAccountOptionsMenu = () => {
  const { setModule } = useContext(ModuleContext);
  const { managedAccountModule } = useContext(ManagedAccountContext);
  const { authState } = useOktaAuth();

  const isTier3 =
      authState.accessToken.claims.itsTier3 ||
      authState.accessToken.claims.distributedItTier3;

  const launch = (element, isLog = true) => {
    setModule((prev) => ({
      ...prev,
      isVisible: true,
      userId: managedAccountModule.upn,
      element,
      isLog,
    }));
  };

  const menuItems = useMemo(() => {
    const items = [];

    const section = (label) => items.push({ type: "section", label });
    const item = (label, component, isLog = true) =>
        items.push({ type: "item", label, component, isLog });

    section("General");
    item("Tech tools action history", <ActivityLog userId={managedAccountModule.upn} />);

    section("Managed account");
    if (isTier3) {
      item("Update managed account", <UpdateManagedAccount />);
      item("Delete managed account", <DeleteManagedAccount />);
    }

    return items;
  }, [isTier3, managedAccountModule.upn]);

  return (
      <Fragment>
        <div style={{ marginTop: 20 }}>
          {menuItems.map((entry, i) =>
              entry.type === "section" ? (
                  <Fragment key={`section-${entry.label}`}>
                    {i !== 0 && <Divider sx={{ mx: 1, my: 0.5 }} />}
                    <ListSubheader disableSticky sx={sectionSx}>
                      {entry.label}
                    </ListSubheader>
                  </Fragment>
              ) : (
                  <MenuItem
                      key={entry.label}
                      onClick={() => launch(entry.component, entry.isLog)}
                      sx={pillSx}
                  >
                    {entry.label}
                  </MenuItem>
              )
          )}
        </div>
      </Fragment>
  );
};